<template>
<div>
    <!-- TPA Account List -->
    <v-card class="ma-5 px-5">
        <v-card-title>
            <div class="text-h4 primary--text font-weight-light">TPA Accounts</div>
        </v-card-title>
        <v-card-text class="card">
            <v-row v-for="tpa in tpaList"
            :key="tpa.id"
            class="list-item"
            @click="selectTpaFromList(tpa)">
                <v-col class="py-0">
                    <v-row :id="tpa.tpa_id">
                        <v-col cols="12" style="font-size:18px;">
                            {{tpa.tpa_name}}
                        <v-tooltip v-if="!tpa.is_active" top>
                            <template v-slot:activator="{ on }">
                                <v-icon v-on="on" color="amber darken-2">mdi-alert-circle-outline</v-icon>
                            </template>
                            <span>{{tpa.tpa_name}} is inactive!</span>
                        </v-tooltip>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <v-row></v-row>
        </v-card-text>
        <v-card-actions>
            <v-tooltip top>
                <template v-slot:activator="{ on }">
                    <v-btn
                    large
                    color="green lighten-2"
                    dark
                    class="ma-2"
                    v-on="on"
                    elevation=0
                    @click="newTpaButton"
                    >
                    Add New TPA
                    </v-btn>
                </template>
                <span>Create a new TPA account</span>
            </v-tooltip>
        </v-card-actions>
    </v-card>

    <!-- TPA Form -->
    <div class="mx-5">   
        <v-card class="custom-card" outlined>
            <v-col class="ml-5">
                <div class="text-h4 primary--text font-weight-light">
                    {{tpaFormTitle}}
                    <span v-if="tpaHasChanges" class="warn">Changes are not saved!</span>
                </div>
            </v-col>
            <v-col cols="12" class="pb-0">
                <v-container class="pb-0">
                    <v-row no-gutters class="custom-row">
                    <v-col cols="6" class="p-0 pr-5">
                        <v-text-field 
                            v-model="tpaSelected.tpa_name"
                            :error-messages="tpaNameErrors"
                            label="* Company Name"
                            class="pa-0 ma-0"
                            required
                            @change="tpaHasChanges = true">
                        </v-text-field>
                    </v-col>
                    <v-col cols="3" class="p-0 pl-5">
                        <v-text-field 
                            v-model="tpaSelected.voya_plan"
                            label="# of Voya Accounts"
                            outlined dense
                            class="pa-0 ma-0"
                            @change="tpaHasChanges = true">
                        </v-text-field>
                    </v-col>
                    <v-col cols="3" class="p-0 pl-5">
                        <v-text-field 
                            v-model="tpaSelected.tpa_short_name"
                            :error-messages="tpaShortNameErrors"
                            label="* Company Short Name"
                            outlined dense
                            class="pa-0 ma-0"
                            required
                            @change="tpaHasChanges = true">
                        </v-text-field>
                    </v-col>
                    </v-row>
                    <v-row no-gutters class="custom-row">
                    <v-col cols="6" class="p-0 pr-5">
                        <v-text-field 
                            v-model="tpaSelected.tpa_primary_email"
                            label="Primary Email"
                            class="pa-0 ma-0"
                            @change="tpaHasChanges = true">
                        </v-text-field>
                    </v-col>
                    <v-col cols="6" class="p-0 pl-5">
                        <v-text-field 
                            v-model="tpaSelected.tpa_address"
                            label="Company Address"
                            class="pa-0 ma-0"
                            @change="tpaHasChanges = true">
                        </v-text-field>
                    </v-col>
                    </v-row>
                    <v-row no-gutters class="custom-row">
                    <v-col cols="6" class="p-0 pr-5">
                        <v-text-field 
                            v-model="tpaSelected.tpa_primary_phone"
                            label="Primary Phone"
                            class="pa-0 ma-0"
                            @change="tpaHasChanges = true">
                        </v-text-field>
                    </v-col>
                    <v-col cols="6" class="p-0 pl-5">
                        <v-row no-gutters>
                            <v-col cols="6" class="p-0 pr-5">
                                <v-text-field 
                                v-model="tpaSelected.tpa_city"
                                label="Company City"
                                class="pa-0 ma-0"
                                @change="tpaHasChanges = true">
                                </v-text-field>
                            </v-col>
                            <v-col cols="6" class="p-0 pl-5">
                                <v-text-field 
                                v-model="tpaSelected.tpa_state"
                                label="Company State"
                                class="pa-0 ma-0"
                                @change="tpaHasChanges = true">
                                </v-text-field>
                            </v-col>
                        </v-row>
                    </v-col>
                    </v-row>
                    <v-row no-gutters class="custom-row">
                    <v-col cols="6" class="p-0  pr-5">
                        <v-text-field 
                            v-model="tpaSelected.tpa_primary_contactname"
                            label="Primary Contact Name"
                            class="pa-0 ma-0"
                            @change="tpaHasChanges = true">
                        </v-text-field>
                    </v-col>
                    <v-col cols="6" class="p-0 pl-5">
                        <v-row no-gutters>
                            <v-col cols="6" class="p-0 pr-5">
                                <v-text-field 
                                v-model="tpaSelected.tpa_zip"
                                label="Company ZipCode"
                                class="pa-0 ma-0"
                                @change="tpaHasChanges = true">
                                </v-text-field>
                            </v-col>
                            <v-col cols="3" class="p-0 pl-5">
                                <v-checkbox 
                                v-model="tpaSelected.is_active"
                                label="Is Active"
                                @change="tpaHasChanges = true">
                                </v-checkbox>
                            </v-col>
                            <v-col cols="3" class="p-0 pl-5" style="text-align:end;">
                                <v-btn color="primary" dark @click="submitTpaForm">Save Changes</v-btn>
                            </v-col>
                        </v-row>
                    </v-col>
                    </v-row>
                </v-container>
            </v-col>
        </v-card>
    </div>

    <!-- User List -->
    <v-card class="ma-5 px-5">
        <v-card-title>
            <div class="text-h4 primary--text font-weight-light">User Accounts</div>
        </v-card-title>
        <v-card-text class="card">
            <v-row v-for="user in userList"
            :key="user.id"
            class="list-item"
            @click="selectUserFromList(user)">
                <v-col class="py-0">
                    <v-row :id="user.user_id">
                        <v-col cols="12" style="font-size:18px;">
                            {{user.name}}
                        <v-tooltip v-if="!user.is_active" top>
                            <template v-slot:activator="{ on }">
                                <v-icon v-on="on" color="amber darken-2">mdi-alert-circle-outline</v-icon>
                            </template>
                            <span>{{user.name}} is inactive!</span>
                        </v-tooltip>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <v-row></v-row>
        </v-card-text>
        <v-card-actions>
            <v-tooltip top>
                <template v-slot:activator="{ on }">
                    <v-btn
                    large
                    color="green lighten-2"
                    dark
                    class="ma-2"
                    v-on="on"
                    elevation=0
                    @click="newUserButton"
                    :disabled="userFormDisabled"
                    >
                    Add New User
                    </v-btn>
                </template>
                <span>Create a new User account</span>
            </v-tooltip>
        </v-card-actions>
    </v-card>

    <!-- User Form -->
    <div class="mx-5">   
        <v-card class="custom-card" outlined>
            <v-col class="ml-5">
                <div class="text-h4 primary--text font-weight-light">
                    {{userFormTitle}}
                    <span v-if="userHasChanges" class="warn">Changes are not saved!</span>
                </div>
            </v-col>
            <v-col cols="12" class="pb-0">
                <v-container class="pb-0">
                <v-row>
                    <v-col cols="4" class="px-5">
                        <v-text-field 
                            v-model="userSelected.name"
                            :error-messages="userNameErrors"
                            label="* Name"
                            class="pa-0 ma-0"
                            required
                            @change="userHasChanges = true"
                            :disabled="userFormDisabled">
                        </v-text-field>
                    </v-col>
                    <v-col cols="4" class="px-5">
                        <v-text-field 
                            v-model="userSelected.email"
                            :error-messages="userEmailErrors"
                            label="* Email"
                            class="pa-0 ma-0"
                            required
                            @change="userHasChanges = true"
                            :disabled="userFormDisabled">
                        </v-text-field>
                    </v-col>
                    <v-col cols="4" class="px-5">
                        <v-text-field 
                            v-model="userSelected.title"
                            label="Title"
                            class="pa-0 ma-0"
                            @change="userHasChanges = true"
                            :disabled="userFormDisabled">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="4" class="px-5">
                        <v-text-field 
                            v-model="userSelected.date_joined"
                            label="Date Joined"
                            class="pa-0 ma-0"
                            disabled>
                        </v-text-field>
                    </v-col>
                    <v-col cols="4" class="px-5">
                        <v-checkbox 
                            v-model="userSelected.is_active"
                            label="Is Active"
                            @change="userHasChanges = true"
                            :disabled="userFormDisabled">
                        </v-checkbox>
                    </v-col>
                    <v-col cols="4" class="px-5" style="text-align:end;">
                        <v-btn 
                            color="primary" 
                            dark
                            @click="submitUserForm"
                            :disabled="userFormDisabled">Save Changes
                        </v-btn>
                    </v-col>
                </v-row>
                </v-container>
            </v-col>
        </v-card>
    </div>

    <!-- Warning -->
    <v-dialog max-width="350" v-model="warn.show" persistent>
        <v-card>
            <v-card-title>
                <v-col cols="12" style="text-align:center;font-size:40px;">! ! WARNING ! !</v-col>
            </v-card-title>
            <v-card-text style="text-align:center;" v-if="warn.type === 'tpa'">
                You are about to deactivate your own comany account! No {{tpaSelected.tpa_name}} users will be able to log into Rapid Quote including YOU!
            </v-card-text>
            <v-card-text style="text-align:center;" v-else>
                You are about to deactivate<br/>YOUR ACCOUNT!<br/>You will not be able<br/>to log back into Rapid Quote!
            </v-card-text>
            <v-card-actions>
                <v-btn color="red darken-3" text @click="warn.show = false">Deactivate</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="green darken-3" text @click="cancelDeactivate">Cancel</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
<div style="min-height:200px;"></div>
</div>
  
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import { TPA, User } from '@/store/modules/dataModels.js';
  import { getTPAID, getUSERID } from '@/store/global_helpers/sessionReturn.js';

  export default {
    data: () => ({
        modes: {
            EDIT: 'edit',
            CREATE: 'create',
            DISABLE: 'disable',
        },
        tpaSelected: new TPA(),
        tpaHasChanges: false,
        tpaFormSubmitting: false,
        tpaMode: null,

        userSelected: new User(),
        userHasChanges: false,
        userFormSubmitting: false,
        userMode: null,

        loggedInUserID: false,
        loggedInTpaID: false,
        warn: {
            show: false,
            type: null
        }
    }),

    mounted() {
        this.adminGetTpaList();
        this.adminClearUserList();
        this.loggedInTpaID = getTPAID();
        this.loggedInUserID = getUSERID();
    },

    computed: {
        ...mapGetters({ 
            tpaList: 'getSiteAdminTpaList',
            userList: 'getSiteAdminUserList',
        }),
        
        tpaFormTitle(){
            if (this.tpaMode === this.modes.EDIT){
                return `Edit: ${this.tpaSelected.tpa_name}`
            } else {
                return "Add New TPA"
            }
        },
        
        userFormTitle(){
            if (this.userMode === this.modes.EDIT){
                return `Edit: ${this.userSelected.name}`
            } else {
                return "Add New User"
            }
        },

        userFormDisabled(){
            if (this.tpaSelected.tpa_id === null) {
                return true;
            } else {
                return false;
            }
        },

        tpaNameErrors () {
            if (!this.tpaFormSubmitting) return [];
            const errors = [];
            if (this.tpaSelected.tpa_name === null || this.tpaSelected.tpa_name === "") {
                errors.push("Required");
            }
            return errors;
        },

        tpaShortNameErrors() {
            if (!this.tpaFormSubmitting) return [];
            const errors = [];
            if (this.tpaSelected.tpa_short_name === null || this.tpaSelected.tpa_short_name === "") {
                errors.push("Required");
            }
            return errors;
        },

        userNameErrors() {
            if (!this.userFormSubmitting) return [];
            const errors = [];
            if (this.userSelected.name === null || this.userSelected.name === "") {
                errors.push("Required");
            }
            return errors;
        },

        userEmailErrors() {
            if (!this.userFormSubmitting) return [];
            const errors = [];
            if (this.userSelected.email === null || this.userSelected.email === "") {
                errors.push("Required");
            }
            return errors;
        },
    },

    watch: {
        
        'tpaSelected.is_active'(){
            if (this.tpaSelected.tpa_id === this.loggedInTpaID && !this.tpaSelected.is_active){
                this.warn.show = true;
                this.warn.type = 'tpa';
            }
        },
        
        'userSelected.is_active'(){
            if (this.userSelected.user_id === this.loggedInUserID && !this.userSelected.is_active){
                this.warn.show = true;
                this.warn.type = 'user';
            }
        },
    },

    methods: {
        ...mapActions([
            'adminCreateTpa',
            'adminUpdateTpa',
            'adminGetTpaList',
            'adminCreateUser',
            'adminUpdateUser',
            'adminGetUserList',
            'adminClearUserList'
            ]),

        selectTpaFromList(tpa){
            this.tpaHasChanges = false;
            this.tpaFormSubmitting = false;
            this.tpaMode = this.modes.EDIT;
            this.tpaSelected = tpa;
            this.changeSelectedElement(tpa.tpa_id,'tpa');

            this.adminGetUserList(tpa.tpa_id)
            this.userSelected = new User({tpa_id:this.tpaSelected.tpa_id});
            this.userHasChanges = false;
            this.userMode = this.modes.CREATE
            this.changeSelectedElement(null,'user');
        },

        newTpaButton(){
            this.tpaHasChanges = false;
            this.tpaFormSubmitting = false;
            this.tpaMode = this.modes.CREATE
            this.tpaSelected = new TPA();
            this.changeSelectedElement(null,'tpa');

            this.adminClearUserList();
            this.userSelected = new User();
            this.userHasChanges = false;
            this.userMode = this.modes.DISABLE
            // this.changeSelectedElement(null,'user');
        },

        submitTpaForm(){
            this.tpaFormSubmitting = true;
            if (this.tpaFormHasErrors()) return;
            if (this.tpaMode === this.modes.CREATE){
                this.adminCreateTpa(this.tpaSelected)
                this.tpaHasChanges = false;
            } else if (this.tpaMode === this.modes.EDIT) {
                this.adminUpdateTpa(this.tpaSelected);
                this.tpaHasChanges = false;
                this.changeSelectedElement(this.tpaSelected.tpa_id,'tpa');
            }
            this.tpaFormSubmitting = false;
        },

        tpaFormHasErrors(){
            let hasErrors =  false;
            let attrs = [this.tpaSelected.tpa_name,this.tpaSelected.tpa_short_name];
            attrs.forEach((attr) => {
                if (attr === null || attr === 'undefined' || attr === "") hasErrors = true;
            })
            return hasErrors;
        },

        newUserButton(){
            this.userHasChanges = false;
            this.userFormSubmitting = false;
            this.userMode = this.modes.CREATE
            this.userSelected = new User({tpa_id:this.tpaSelected.tpa_id});
        },

        selectUserFromList(user){
            this.userHasChanges = false;
            this.userFormSubmitting = false;
            this.userMode = this.modes.EDIT;
            this.userSelected = user;
            this.changeSelectedElement(user.user_id,'user');
        },

        submitUserForm(){
            this.userFormSubmitting = true;
            if (this.userFormHasErrors()) return;
            if (this.userMode === this.modes.CREATE){
                this.adminCreateUser(this.userSelected.toJson());
                this.userHasChanges = false;
                this.userMode = this.modes.CREATE
                this.userSelected = new User({tpa_id:this.tpaSelected.tpa_id});
                this.changeSelectedElement(null,'user');
            } else if (this.userMode === this.modes.EDIT) {
                this.adminUpdateUser(this.userSelected);
                this.userHasChanges = false;
                this.changeSelectedElement(this.userSelected.user_id,'user');
            }
            this.userFormSubmitting = false;
        },

        userFormHasErrors(){
            let hasErrors = false
            let attrs = [this.userSelected.name,this.userSelected.email]
            attrs.forEach((attr) => {
                if (attr === null || attr === 'undefined' || attr === "") hasErrors = true
            })
            return hasErrors
        },

        changeSelectedElement(id,list){
            let eles = document.querySelectorAll(`.selected-${list}`)
            eles.forEach((e) => {
                e.classList.remove(`selected-${list}`);
                })
            if (id) {
                let ele = document.getElementById(id)
                ele.classList.add(`selected-${list}`)
            }
        },

        cancelDeactivate(){
            if (this.warn.type === 'tpa'){
                this.tpaSelected.is_active = true;
            } else {
                this.userSelected.is_active = true;
            }
            this.warn.show = false;
        }
    },

    components: { },
  };
</script>

<style scoped>
.list-item {
    cursor: pointer;
}
.list-item:hover {
    background-color: rgb(210, 230, 255)
}
.selected-tpa {
    border:1px solid blue;
    border-radius:4px;
}
.selected-user {
    border:1px solid blue;
    border-radius:4px;
}
.warn {
    font-size: 16px;
    color: rgb(250, 100, 50);
}
.card {
    max-height:300px;
    min-height:300px;
    overflow-y:scroll;
    overflow-x:hidden;
    border:1px solid #ddd;
    border-radius: 5px;
}
</style>

